import { render, staticRenderFns } from "./TagCheck.vue?vue&type=template&id=6f5071a5"
import script from "./TagCheck.vue?vue&type=script&lang=js"
export * from "./TagCheck.vue?vue&type=script&lang=js"
import style0 from "./TagCheck.vue?vue&type=style&index=0&id=6f5071a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports